<template>
  <div>
    <v-col cols="12" md="9" sm="12" class="mx-auto">
      <v-card v-if="userGroupByStatus.length !== 0">
        <div class="text-center">
          <v-col md="6" cols="12" sm="12" class="mx-auto">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search User"
              single-line
              dense
              outlined
              hide-details
            ></v-text-field>
          </v-col>

          <v-chip class="ma-2" color="green" text-color="white">
            <b>Active:</b>&nbsp;
            <span>{{ userGroupByStatus.active.length }}</span>
          </v-chip>

          <v-chip class="ma-2">
            <b>Inactive:</b>&nbsp;
            <span>{{ userGroupByStatus.inactive.length }}</span>
          </v-chip>

          <v-chip class="ma-2" color="primary">
            <b>Trialing:</b>&nbsp;
            <span>{{ userGroupByStatus.trialing.length }}</span>
          </v-chip>

          <v-chip class="ma-2" color="red" text-color="white">
            <b>Past Due:</b>&nbsp;
            <span>{{ userGroupByStatus.past_due.length }}</span>
          </v-chip>

          <!-- <v-chip class="ma-2" color="secondary">
            <b>Incomplete:</b>&nbsp;
            <span>{{ userGroupByStatus.incomplete.length }}</span>
          </v-chip> -->

          <!-- <v-chip class="ma-2" color="light-blue" text-color="white">
            <b>Incomplete Expired:</b>&nbsp;
            <span>{{ userGroupByStatus.incomplete_expired.length }}</span>
          </v-chip> -->
        </div>
      </v-card>

      <!--  -->
      <v-data-table
        :headers="Headers"
        :items="AllUsers.data"
        :items-per-page="10"
        class="elevation-1"
        mobile-breakpoint="0"
        :footerProps="footerProps"
        :search="search"
      >
        <template v-slot:top>
          <!-- delete user popup -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h6"
                >Are you sure you want to delete this User?
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- delete user popup -->

          <!-- update password form -->
          <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <v-form>
                <div align="center">
                  <v-col cols="12" md="12" sm="12" align="center">
                    <p class="body-1 green--text font-weight-bold">
                      Update Password for
                      <span class="black--text">{{ user }}</span>
                    </p>
                  </v-col>
                </div>

                <!-- //* New password -->
                <div align="center" class="mt-n5">
                  <v-col cols="12" md="8" sm="12">
                    <v-text-field
                      class="input"
                      v-model="form.NewPassword"
                      :rules="passwordRules"
                      label="New Password*"
                      :type="showNewPassword ? 'text' : 'password'"
                      :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showNewPassword = !showNewPassword"
                      outlined
                      filled
                      required
                      prepend-inner-icon="mdi-form-textbox-password"
                    ></v-text-field>
                  </v-col>
                </div>

                <!-- //* button -->
                <div align="center" class="mt-n5">
                  <v-col cols="12" md="8" sm="12" class="mt-n5">
                    <v-btn block color="#00C853" @click="register" class="mr-4">
                      <v-progress-circular
                        v-if="buttonLoader"
                        indeterminate
                        :width="5"
                        color="primary"
                      ></v-progress-circular>
                      Confirm
                    </v-btn>
                  </v-col>
                </div>

                <v-col cols="12" md="12" align="center">
                  <v-btn color="blue darken-1" text @click="closeDelete"
                    >Cancel
                  </v-btn>
                </v-col>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- update password form ends-->

          <!-- cancel subs popup -->
          <v-dialog v-model="subsDialog" max-width="450px">
            <v-card class="pa-2">
              <v-form>
                <div align="center">
                  <p class="body-1 pa-1 black--text">
                    Are you sure you want to Cancle Subscription for
                    <span class="red--text">{{ user }}</span
                    >?
                  </p>
                </div>

                <!-- //* button -->
                <v-card-actions class="mt-n5 d-flex justify-space-between">
                  <v-btn small color="warning" @click="cancelSubs()">
                    <v-progress-circular
                      v-if="buttonLoader"
                      indeterminate
                      :width="5"
                      color="success"
                    ></v-progress-circular>
                    Confirm
                  </v-btn>

                  <v-btn color="blue darken-1" text @click="closeDelete">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- cancel subs popup -->

          <!-- user last activity -->
          <v-dialog v-model="activityDialog" max-width="200px">
            <v-card>
              <div align="center">
                <v-col cols="12" md="12" sm="12" align="center">
                  <p
                    v-if="lastActivity.doc"
                    class="body-1 pa-1 green--text font-weight-bold"
                  >
                    Last activity of {{ user }} <br />
                    <span class="black--text"
                      >Sports: {{ lastActivity.doc.SportType }}</span
                    ><br />
                    <span class="black--text"
                      >Day: {{ lastActivity.doc.day | dayFormat }}</span
                    >
                  </p>
                  <p v-else-if="!lastActivity.doc">Nothing here!</p>
                </v-col>
              </div>
              <!-- //* button -->

              <v-col cols="12" md="12" align="center" class="mt-n4">
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Close
                </v-btn>
              </v-col>
            </v-card>
          </v-dialog>
          <!-- user last activity -->

          <!-- create trial popup -->
          <v-dialog v-model="trialDialog" max-width="450px">
            <v-card class="pa-2">
              <v-form>
                <div align="center">
                  <p class="body-1 pa-1 font-weight-bold">
                    Are you sure you want to create free trial for
                    <span class="green--text">{{ user }}</span> ?
                  </p>
                </div>

                <!-- //* button -->
                <v-card-actions class="mt-n5 d-flex justify-space-between">
                  <v-btn small color="success" @click="setTrial()">
                    <v-progress-circular
                      v-if="buttonLoader"
                      indeterminate
                      :width="5"
                      color="success"
                    ></v-progress-circular>
                    Confirm
                  </v-btn>

                  <v-btn color="blue darken-1" text @click="closeDelete">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- create trial popup -->
        </template>

        <template v-slot:item.subscription="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                color="red accent-2"
                small
                class="mr-2"
                @click="userDetail(item)"
              >
                mdi-account-cancel
              </v-icon>
            </template>
            <span>Cancel Subscription</span>
          </v-tooltip>
        </template>

        <template v-slot:item.createTrial="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                color="blue accent-2"
                small
                class="mr-2"
                @click="createTrial(item)"
              >
                mdi-account-circle
              </v-icon>
            </template>
            <span>Create trial Account</span>
          </v-tooltip>
        </template>

        <template v-slot:item.activity="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                color="cyan darken-3"
                small
                class="mr-2"
                @click="fetchLastActivity(item)"
              >
                mdi-account-eye
              </v-icon>
            </template>
            <span>Last activity</span>
          </v-tooltip>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class="mr-2" @click="recoverPass(item)">
                mdi-account-key
              </v-icon>
            </template>
            <span>Recover password</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small @click="deleteUser(item)" color="red">
                mdi-delete
              </v-icon>
            </template>
            <span>Delete user</span>
          </v-tooltip>
        </template>

        <template v-slot:item.createdAt="{ item }">
          <p>{{ item.createdAt | dayFormatV2 }}</p>
        </template>
      </v-data-table>
    </v-col>
  </div>
</template>
<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
  name: "allUsersTable",
  data() {
    return {
      // valid: true,
      footerProps: {
        "items-per-page-options": [15, 50, 100, 200, -1],
      },
      user: "",
      userId: "",
      search: "",
      user_stripe_Subscription_id: "",
      userGroupByStatus: [],
      buttonLoader: false,
      dialog: false,
      dialogDelete: false,
      subsDialog: false,
      trialDialog: false,
      activityDialog: false,
      showNewPassword: false,
      deleteIndex: -1,
      editedItem: {},
      Headers: [
        { text: "Name", value: "userName", align: "center", width: 20 },
        {
          text: "Email ",
          value: "email",
          align: "center",
        },
        { text: "Payment status", value: "paymentType", align: "center" },
        { text: "Status", value: "status", align: "center" },
        {
          text: "Action",
          value: "actions",
          sortable: false,
          align: "center",
        },
        {
          text: "Last Activity",
          value: "activity",
          sortable: false,
          align: "center",
        },
        {
          text: "Cancel Subs",
          value: "subscription",
          sortable: false,
          align: "center",
        },
        {
          text: "Create trials",
          value: "createTrial",
          sortable: false,
          align: "center",
        },
        {
          text: "Created",
          value: "createdAt",
          align: "center",
        },
      ],
      form: {
        NewPassword: "",
      },
      passwordRules: [
        (v) =>
          (v && /^[a-z0-9\-]+$/.test(v)) ||
          `Only lowercase letters, numbers or hyphens allowed`,
        (v) => v.length >= 6 || "Min 6 characters",
      ],
    };
  },

  created() {
    this.fetchAllUsers();
  },
  computed: {
    ...mapState("NbaModule", ["AllUsers", "lastActivity"]),
    // ...mapGetters('NbaModule', ['userLoader']),
  },
  methods: {
    groupByStatus(arr, status) {
      this.userGroupByStatus = _.groupBy(arr, status);
      console.log("newVal", this.userGroupByStatus);
    },

    fetchAllUsers() {
      this.$store.dispatch("NbaModule/getAllUsers").then(() => {
        this.groupByStatus(this.AllUsers.data, "status");
      });
    },

    register() {
      this.buttonLoader = true;
      // this.$refs.form1.validate();
      this.$store
        .dispatch("NbaModule/updateUserPassword", {
          userId: this.userId,
          newPassword: this.form.NewPassword,
        })
        .then(() => {
          this.dialog = false;
          this.buttonLoader = false;
        });
    },
    recoverPass(user) {
      this.user = user.userName;
      this.userId = user._id;
      this.dialog = true;
    },

    deleteUser(user) {
      this.dialogDelete = true;
      this.deleteIndex = this.AllUsers.data.indexOf(user);
      this.editedItem = Object.assign({}, user);
    },
    updateUser() {
      let obj = {
        userId: this.editedItem._id,
      };
      this.$store.dispatch("NbaModule/deleteUser", obj).then(() => {
        // player index.
        this.$store.dispatch("NbaModule/getAllUsers");
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.dialog = false;
      this.subsDialog = false;
      this.activityDialog = false;
      this.trialDialog = false;
    },

    deleteItemConfirm() {
      this.updateUser();
      this.closeDelete();
    },

    userDetail(user) {
      this.user = user.userName;
      this.userId = user._id;
      this.user_stripe_Subscription_id = user.stripe_Subscription_id;
      this.subsDialog = true;
    },

    createTrial(user) {
      this.user = user.userName;
      this.userId = user._id;
      this.user_stripe_Subscription_id = user.stripe_Subscription_id;
      this.trialDialog = true;
    },

    cancelSubs() {
      this.buttonLoader = true;
      let obj = {
        stripe_subscription_id: this.user_stripe_Subscription_id,
        userId: this.userId,
      };
      this.$store.dispatch("NbaModule/cancelSubscription", obj).then(() => {
        this.subsDialog = false;
        this.buttonLoader = false;
      });
    },

    setTrial() {
      this.buttonLoader = true;
      let obj = {
        role: "client",
        userId: this.userId,
      };
      this.$store
        .dispatch("userModule/createFreeSubscription", obj)
        .then(() => {
          this.trialDialog = false;
          this.buttonLoader = false;
        });
    },

    fetchLastActivity(user) {
      this.user = user.userName;
      this.activityDialog = true;
      this.$store.dispatch("NbaModule/userLastActivity", {
        userid: user._id,
      });
    },
  },
};
</script>

<style scoped>
.input >>> input {
  color: rgba(0, 0, 0, 0.87);
  margin-top: 0px;
}
</style>
